/* ==========================================================================
   SearcherFli > Product > Constants
   ========================================================================== */

const ROUNDTRIP = 'roundtrip';
const ONEWAY = 'oneway';
const OPENJAW = 'openjaw';

/* Exports */
module.exports = {
    ROUNDTRIP,
    ONEWAY,
    OPENJAW
};
